import TemplateContents from "./TemplateContents";

import { gsap } from "gsap";
import { Flip } from "gsap/Flip";

gsap.registerPlugin(Flip);

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
    this.openedInner = false;
    this.initMotionLen = 24;
  }

  setDom() {
    super.setDom();

    this.section5Dom = document.querySelector("main.top .section5");
    this.section4Dom = document.querySelector("main.top .section4");

    this.listContainer = document.querySelector("main.top .section4 .list");
    this.generateList();

    this.itemAll = document.querySelectorAll("main.top .section4 .list .item");
    this.filterUIDom = document.querySelector("main.top .section4 .filter_ui");
    this.filterBtnAll = document.querySelectorAll(
      "main.top .section4 .filter_ui li",
    );

    //高さに制限を加えているdom
    this.productsInner = document.querySelector(
      "main.top .section4 .products_inner",
    );

    //実際の高さがわかるdom
    this.contentstWrapper = document.querySelector(
      "main.top .section4 .content_wrapper",
    );

    this.moreBtn = document.querySelector("main.top .section4 .more_btn2");
    this.backBtn = document.querySelector("main.top .section4 .back_btn");
    this.toECBtn = document.querySelector("main.top .section4 .to_ec_btn");
  }

  generateList() {
    if (!this.listContainer || !this.pack.productList) return;

    // productListのインデックス順に対応する画像ファイル名
    const productImgFiles = [
      // "01.webp",
      // "07.webp",
      "13.webp",
      "14.webp",
      "15-1.webp",
      "16-1.webp",
      "17-1.webp",
      "18-1.webp",
      "19.webp",
      "21.webp",
      "28.webp",
      "32.webp",
      // "37.webp",
      // "38.webp",
      // "40.webp",
      "41.webp",
      // "54.webp",
      // "57.webp",
      "58.webp",
      "59.webp",
      // "60.webp",
      "61.webp",
      "62.webp",
      "63.webp",
      "65.webp",
      "66.webp",
      "67.webp",
      "68.webp",
      "69.webp",
      "70.webp",
      "71.webp",
      "72.webp",
      "73.webp",
      "75.webp",
      "76.webp",
      "77.webp",
      "79.webp",
      "81.webp",
    ];

    // 0. 画像と元の順番を productList に紐付ける (Config順 = モーダルの並び順)
    this.pack.productList.forEach((item, index) => {
      if (productImgFiles[index]) {
        item.image = productImgFiles[index];
      }

      item.originalIndex = index;
    });

    // 1. id === 0 のデータを削除した配列を作成
    const filteredList = this.pack.productList.filter((item) => item.id !== 0);

    // 2. IDでソートした配列を作成
    this.sortedProductList = filteredList.sort((a, b) => a.id - b.id);

    // HTML生成
    let html = "";
    const imgBasePath = this.pack.ASSETS_PATH + "img/top/products/fv/";

    this.sortedProductList.forEach((item) => {
      const imgSrc = item.image ? imgBasePath + item.image : "";
      const isPick = item.pickup ? "pick" : "";
      const hoverImgClass = item.text_color === "black" ? "black" : "";

      html += `
        <li class="item ${isPick}">
          <div class="item_inner">
            <div>
              <div class="img_wrap">
                <div class="hover_img ${hoverImgClass}" style="background-color: ${item.key_color};"></div>
                <img class="main_img" src="${imgSrc}" alt="${item.tit}">
              </div>
              <div class="hover_content">
                <div class="copy condensed">${item.copy}</div>
                <div class="tit condensed">${item.tit}</div>
              </div>
            </div>
          </div>
        </li>
      `;
    });

    // リストに挿入
    this.listContainer.innerHTML = html;

    this.itemAll = document.querySelectorAll("main.top .section4 .list .item");
    this.itemInnerAll = document.querySelectorAll(
      "main.top .section4 .list .item .item_inner",
    );
    this.hoverImgAll = document.querySelectorAll(
      "main.top .section4 .list .item .img_wrap .hover_img",
    );
    this.mainImgAll = document.querySelectorAll(
      "main.top .section4 .list .item .img_wrap .main_img",
    );

    for (let i = 0, len = this.initMotionLen; i < len; i++) {
      let item = this.itemInnerAll[i];
      gsap.set(item, { scale: 0 });
    }

    this.initEvents2();
  }

  initEvents() {
    super.initEvents();

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.show();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -50% 0px" },
    );
    observer.observe(this.section4Dom);

    if (!this.pack.hasTouch) {
      this.moreBtn.addEventListener("mouseover", (event) => {
        this.pack.commonMouseOver(this.moreBtn);
      });

      this.moreBtn.addEventListener("mouseout", (event) => {
        this.pack.commonMouseOut(this.moreBtn);
      });

      this.backBtn.addEventListener("mouseover", (event) => {
        this.pack.commonMouseOver(this.backBtn);
      });

      this.backBtn.addEventListener("mouseout", (event) => {
        this.pack.commonMouseOut(this.backBtn);
      });

      this.toECBtn.addEventListener("mouseover", (event) => {
        this.pack.commonMouseOver(this.toECBtn);
      });

      this.toECBtn.addEventListener("mouseout", (event) => {
        this.pack.commonMouseOut(this.toECBtn);
      });
    }

    this.moreBtn.addEventListener("click", (event) => {
      this.openedInner = true;
      this.changeInnerHeight();
      this.section4Dom.classList.add("hide_gradient");
      this.moreBtn.classList.add("hide");
      gsap.delayedCall(0.7, () => {
        this.backBtn.classList.remove("hide");
      });
    });

    this.backBtn.addEventListener("click", (event) => {
      this.openedInner = false;
      let targetHeight = this.sw >= this.pack.BP ? "120rem" : "90.1rem";

      this.backBtn.classList.add("hide");

      gsap.delayedCall(0.7, () => {
        this.section4Dom.classList.remove("hide_gradient");
        this.moreBtn.classList.remove("hide");
      });

      gsap.to(this.productsInner, {
        duration: 1.0,
        height: targetHeight,
        ease: "quart.inOut",
      });
      let target = this.section4Dom;
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize,
      );
      const targetTop =
        target.getBoundingClientRect().top +
        window.pageYOffset +
        rootFontSize * 120 -
        this.sh;
      this.pack.anchorScroll(targetTop);
    });

    if (!this.filterBtnAll || this.filterBtnAll.length === 0) return;

    for (let i = 0, len = this.filterBtnAll.length; i < len; i++) {
      let btn = this.filterBtnAll[i];
      const btnIndex = i; // ループの外でもインデックスを保持

      if (!this.pack.hasTouch) {
        btn.addEventListener("mouseover", (event) => {
          if (!btn.classList.contains("current"))
            this.pack.commonMouseOver(btn, 1.05);
        });

        btn.addEventListener("mouseout", (event) => {
          if (!btn.classList.contains("current")) this.pack.commonMouseOut(btn);
        });
      }

      btn.addEventListener("click", () => {
        // すでに選択されているボタンなら何もしない
        if (btn.classList.contains("current")) {
          return;
        }

        // 1. ボタンの選択状態（.currentクラス）を更新
        this.filterBtnAll.forEach((b) => b.classList.remove("current"));
        btn.classList.add("current");

        // 2. DOM変更前の、各アイテムの位置やサイズを記録
        // 親(.item)の状態を記録します
        const state = Flip.getState(this.itemAll);

        // ★重要: absolute化で幅の108%指定が親要素基準になり巨大化するのを防ぐため、
        // アニメーション前の現在の幅(px)を記憶しておきます
        const widths = new Map();
        this.itemAll.forEach((item) => widths.set(item, item.offsetWidth));

        // 3. アイテムの表示・非表示を切り替える
        this.itemAll.forEach((item, itemIndex) => {
          let shouldShow = false;
          const data = this.sortedProductList[itemIndex];

          // btnIndex 0 は「ALL」、それ以外は categories 配列に btnIndex が含まれているか確認
          if (btnIndex === 0) {
            shouldShow = true;
          } else if (
            data &&
            data.categories &&
            data.categories.includes(btnIndex)
          ) {
            shouldShow = true;
          }

          // shouldShowフラグに応じて is-hidden クラスを付け外し
          if (shouldShow) {
            item.classList.remove("is-hidden");
          } else {
            item.classList.add("is-hidden");
          }
        });

        // ★Flipアニメーション開始前（absoluteになる前）に、フィルタリング後の正しい高さを取得してアニメーションさせる
        if (this.openedInner) this.changeInnerHeight();

        // 4. 記録した状態から、現在の状態へアニメーションさせる
        Flip.from(state, {
          duration: 0.55,
          ease: "quart.inOut",
          absolute: true, // Gridレイアウトのアニメーションには必須
          // 表示されるときのアニメーション

          // ★アニメーション開始時に、記憶した固定幅(px)を適用して巨大化を防ぐ
          onStart: () => {
            this.itemAll.forEach((item) => {
              const w = widths.get(item);
              if (w) item.style.width = `${w}px`;
            });
          },
          // ★アニメーション完了後、固定幅を解除してCSSの%指定に戻す
          onComplete: () => {
            this.itemAll.forEach((item) => (item.style.width = ""));
          },
          onEnter: (elements) =>
            gsap.fromTo(
              elements,
              { scale: 0.0 },
              { scale: 1, duration: 0.8, ease: "elastic.out(0.8, 0.4)" },
            ),
          // 非表示になるときのアニメーション
          onLeave: (elements) =>
            gsap.to(elements, { scale: 0.0, duration: 0.4, ease: "quart.out" }),
        });
      });
    }
  }

  initEvents2() {
    for (let i = 0, len = this.itemAll.length; i < len; i++) {
      let item = this.itemAll[i];
      if (!this.pack.hasTouch) {
        item.addEventListener("mouseover", () => {
          this.pack.commonMouseOver(
            this.mainImgAll[i],
            1.15,
            1,
            "elastic.out(1.8, 0.25)",
          );
          this.mouseOverRotate(this.hoverImgAll[i]);
        });

        item.addEventListener("mouseout", () => {
          this.pack.commonMouseOut(this.mainImgAll[i]);
          this.mouseOutRotate(this.hoverImgAll[i]);
        });
      }

      item.addEventListener("click", () => {
        let id = this.sortedProductList[i].originalIndex;
        this.pack.productsModal.openModal(id);
      });
    }
  }

  mouseOverRotate(target) {
    gsap.to(target, {
      rotate: 8,
      duration: 0.9,
      ease: "elastic.out(1.7, 0.35)",
      overwrite: true,
    });
  }

  mouseOutRotate(target) {
    gsap.to(target, {
      rotate: 0,
      duration: 0.4,
      ease: "quart.out",
      overwrite: true,
    });
  }

  changeInnerHeight() {
    let targetHeight = this.contentstWrapper.clientHeight;
    const rootFontSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize,
    );
    const addRem = this.sw >= this.pack.BP ? 18 : 10;
    targetHeight += rootFontSize * addRem;
    gsap.to(this.productsInner, {
      duration: 1.5,
      height: targetHeight,
      ease: "quart.inOut",
    });
  }

  start() {}

  show() {
    for (let i = 0, len = this.initMotionLen; i < len; i++) {
      let item = this.itemInnerAll[i];
      gsap.to(item, {
        delay: i * 0.04,
        duration: 1.0,
        scale: 1,
        ease: "elastic.out(0.8, 0.4)",
      });
    }
    gsap.delayedCall(1.5, () => {
      this.filterUIDom.classList.add("active");
    });
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();

    if (this.openedInner) this.changeInnerHeight();
  }
}
